import SparePartsFinderTextSearchIndexTableRow
    from '../spare-parts-finder-text-search/SparePartsFinderTextSearchIndexTableRow';
import {observer} from 'mobx-react';
import store from '@lib/store/SparePartsFinderTextSearchBasketStore';
import sparePartsFinderStore from '@lib/store/SparePartsFinderStore';
import SparePartsFinderAddToBasket from '../SparePartsFinderAddToBasket';

const row = observer(
    class SparePartsFinderPOIndexTableRow extends SparePartsFinderTextSearchIndexTableRow {

        renderActions() {
            return (
                <SparePartsFinderAddToBasket
                    isInBasket={store.isInBasket(this.props.searchParameter, this.props.row.id)}
                    onAddToBasketClick={this.addToBasket}
                />
            )
        }

        renderRowInternalActions() {
            if (store.isInBasket(this.props.searchParameter, this.props.row.id)) {
                return <td></td>
            }

            return (
                <td></td>
            )
        }

        addToBasket = () => {
            store.addToBasketIfNotExistsSingle(this.props.searchParameter, this.props.row.id);
            sparePartsFinderStore.setMarketDisable(true);
        }

        createRowKey() {
            return `${this.props.po}-${this.props.row.id}`;
        }
    }
)
export default row;